import type * as Types from '../../../types/graphql';

import type { DocumentNode } from 'graphql';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type CartItemDeleteMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type CartItemDeleteMutation = { __typename?: 'Mutation', cartItemDelete?: { __typename?: 'CartItem', id: string } | null };

export type CartItemUpdateMutationVariables = Types.Exact<{
  input: Types.CartItemUpdateInput;
}>;


export type CartItemUpdateMutation = { __typename?: 'Mutation', cartItemUpdate?: { __typename?: 'CartItem', id: string } | null };

export type PaymentIntentCreateMutationVariables = Types.Exact<{
  cartUuid?: Types.InputMaybe<Types.Scalars['String']['input']>;
  cherryDiscountCode?: Types.InputMaybe<Types.Scalars['String']['input']>;
  giftcardCode?: Types.InputMaybe<Types.Scalars['String']['input']>;
  behalfOfUserCart?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type PaymentIntentCreateMutation = { __typename?: 'Mutation', paymentIntentCreate?: { __typename?: 'PaymentIntentData', paymentIntentId?: string | null, clientSecret?: string | null, freeUid?: string | null } | null };

export type CartUpdateMutationVariables = Types.Exact<{
  input: Types.CartUpdateInput;
}>;


export type CartUpdateMutation = { __typename?: 'Mutation', cartUpdate?: { __typename?: 'Cart', id: string } | null };

export type CartCreateMutationVariables = Types.Exact<{
  input: Types.CartCreateInput;
}>;


export type CartCreateMutation = { __typename?: 'Mutation', cartCreate?: { __typename?: 'Cart', id: string, uuid?: string | null } | null };

export type CherryDiscountValidateMutationVariables = Types.Exact<{
  code: Types.Scalars['String']['input'];
}>;


export type CherryDiscountValidateMutation = { __typename?: 'Mutation', cherryDiscountValidate?: { __typename?: 'CherryDiscount', id: string, percentage?: number | null, code: string } | null };

export type GiftCardValidateMutationVariables = Types.Exact<{
  code: Types.Scalars['String']['input'];
}>;


export type GiftCardValidateMutation = { __typename?: 'Mutation', giftCardValidate?: { __typename?: 'GiftCard', id: string, code: string, residualPrice: number } | null };

export const CartItemDeleteDocument = /*#__PURE__*/ {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"cartItemDelete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cartItemDelete"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class CartItemDeleteGQL extends Apollo.Mutation<CartItemDeleteMutation, CartItemDeleteMutationVariables> {
    document = CartItemDeleteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CartItemUpdateDocument = /*#__PURE__*/ {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"cartItemUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CartItemUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cartItemUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class CartItemUpdateGQL extends Apollo.Mutation<CartItemUpdateMutation, CartItemUpdateMutationVariables> {
    document = CartItemUpdateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PaymentIntentCreateDocument = /*#__PURE__*/ {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"paymentIntentCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cartUuid"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cherryDiscountCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"giftcardCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"behalfOfUserCart"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentIntentCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cartUuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cartUuid"}}},{"kind":"Argument","name":{"kind":"Name","value":"cherryDiscountCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cherryDiscountCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"giftcardCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"giftcardCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"behalfOfUserCart"},"value":{"kind":"Variable","name":{"kind":"Name","value":"behalfOfUserCart"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentIntentId"}},{"kind":"Field","name":{"kind":"Name","value":"clientSecret"}},{"kind":"Field","name":{"kind":"Name","value":"freeUid"}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class PaymentIntentCreateGQL extends Apollo.Mutation<PaymentIntentCreateMutation, PaymentIntentCreateMutationVariables> {
    document = PaymentIntentCreateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CartUpdateDocument = /*#__PURE__*/ {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"cartUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CartUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cartUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class CartUpdateGQL extends Apollo.Mutation<CartUpdateMutation, CartUpdateMutationVariables> {
    document = CartUpdateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CartCreateDocument = /*#__PURE__*/ {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"cartCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CartCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cartCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uuid"}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class CartCreateGQL extends Apollo.Mutation<CartCreateMutation, CartCreateMutationVariables> {
    document = CartCreateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CherryDiscountValidateDocument = /*#__PURE__*/ {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"cherryDiscountValidate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"code"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cherryDiscountValidate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"code"},"value":{"kind":"Variable","name":{"kind":"Name","value":"code"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class CherryDiscountValidateGQL extends Apollo.Mutation<CherryDiscountValidateMutation, CherryDiscountValidateMutationVariables> {
    document = CherryDiscountValidateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GiftCardValidateDocument = /*#__PURE__*/ {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"giftCardValidate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"code"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"giftCardValidate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"code"},"value":{"kind":"Variable","name":{"kind":"Name","value":"code"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"residualPrice"}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class GiftCardValidateGQL extends Apollo.Mutation<GiftCardValidateMutation, GiftCardValidateMutationVariables> {
    document = GiftCardValidateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }